export const intervalLabels = [
  "root", "minor second", "major second", "minor third", "major third", "perfect fourth",
  "augmented fourth / diminished fifth", "perfect fifth", "minor sixth", "major sixth", "minor seventh", "major seventh",
];
